export default "__VITE_ASSET__cd843510__"